<template>
  <div id="app">
    <router-view></router-view>
  </div>
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
    <symbol id="bootstrap" viewBox="0 0 118 94">
      <title>Bootstrap</title>
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M24.509 0c-6.733 0-11.715 5.893-11.492 12.284.214 6.14-.064 14.092-2.066 20.577C8.943 39.365 5.547 43.485 0 44.014v5.972c5.547.529 8.943 4.649 10.951 11.153 2.002 6.485 2.28 14.437 2.066 20.577C12.794 88.106 17.776 94 24.51 94H93.5c6.733 0 11.714-5.893 11.491-12.284-.214-6.14.064-14.092 2.066-20.577 2.009-6.504 5.396-10.624 10.943-11.153v-5.972c-5.547-.529-8.934-4.649-10.943-11.153-2.002-6.484-2.28-14.437-2.066-20.577C105.214 5.894 100.233 0 93.5 0H24.508zM80 57.863C80 66.663 73.436 72 62.543 72H44a2 2 0 01-2-2V24a2 2 0 012-2h18.437c9.083 0 15.044 4.92 15.044 12.474 0 5.302-4.01 10.049-9.119 10.88v.277C75.317 46.394 80 51.21 80 57.863zM60.521 28.34H49.948v14.934h8.905c6.884 0 10.68-2.772 10.68-7.727 0-4.643-3.264-7.207-9.012-7.207zM49.948 49.2v16.458H60.91c7.167 0 10.964-2.876 10.964-8.281 0-5.406-3.903-8.178-11.425-8.178H49.948z">
      </path>
    </symbol>
    <symbol id="facebook" viewBox="0 0 16 16">
      <path
        d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
    </symbol>
    <symbol id="instagram" viewBox="0 0 16 16">
      <path
        d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
    </symbol>
    <symbol id="twitter" viewBox="0 0 16 16">
      <path
        d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
    </symbol>
  </svg>

  <div class="container">
    <footer class="d-flex flex-wrap justify-content-between align-items-center py-2 my-2">
      <div class="col-md-4 d-flex align-items-center">
        <a class="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1" href="#">
          <img src="img/favicon-32x32.png" width="20" height="20" alt="">
        </a>
        <span class="mb-3 mb-md-0 text-body-secondary">&copy; 2023 Z Company, Inc</span>
      </div>

      <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
        <li class="ms-3"><a class="text-body-secondary" href="#"><svg class="bi" width="24" height="24">
              <use xlink:href="#twitter" />
            </svg></a></li>
        <li class="ms-3"><a class="text-body-secondary" href="#"><svg class="bi" width="24" height="24">
              <use xlink:href="#instagram" />
            </svg></a></li>
        <li class="ms-3"><a class="text-body-secondary" href="#"><svg class="bi" width="24" height="24">
              <use xlink:href="#facebook" />
            </svg></a></li>
      </ul>
    </footer>
  </div>
</template>

<script>
import router from './router'
// import LegendaryCursor from "legendary-cursor";

export default {
  name: 'App',
  components: {
    // Khai báo các component sử dụng trong ứng dụng
  },
  router, // Sử dụng router trong ứng dụng
  mounted() {
    // window.addEventListener("load", () => {
    //   LegendaryCursor.init();
    // });
  }
}
</script>

<style>
.note-text {
  position: absolute;
  top: 90px;
  left: 20px;
  font-size: 17px;
  font-family: monospace;
  color: white;
  pointer-events: none;
}

body {
  overflow-x: hidden;
  height: 100vh;
  margin: 0px;
}

body::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

body::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

body::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

h1 {
  position: absolute;
  top: 0px;
  left: 20px;
}

/* .nav-buttons {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 70px;
}

.nav-button {
  background-color: #ccc;
  border: 1px solid black;
  color: #333;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  cursor: pointer;
  flex-grow: 1;
  margin: 0 0px;
}


.active {
  background-color: #f00;
  color: #fff;
} */

.x-axis-label {
  position: absolute;
  top: 90px;
  right: 20px;
  color: #ff0000;
  font-size: 16px;
}

.y-axis-label {
  position: absolute;
  top: 110px;
  right: 20px;
  color: #00ff00;
  font-size: 16px;
}

.z-axis-label {
  position: absolute;
  top: 130px;
  right: 20px;
  color: #0000ff;
  font-size: 16px;
}

.x-axis-label,
.y-axis-label,
.z-axis-label {
  z-index: 1000;
}

.x-color-box {
  top: 92px;
  right: 60px;
  width: 30px;
  height: 12px;
  background-color: red;
  display: inline-block;
  position: absolute;
  margin-right: 10px;
}

.y-color-box {
  top: 112px;
  right: 60px;
  width: 30px;
  height: 12px;
  background-color: green;
  display: inline-block;
  position: absolute;
  margin-right: 10px;
}

.z-color-box {

  top: 132px;
  right: 60px;
  width: 30px;
  height: 12px;
  background-color: blue;
  display: inline-block;
  position: absolute;
  margin-right: 10px;
}

#nav {
  padding: 10px;
  text-align: center;
}

#nav a {
  font-size: 12px;
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: whitesmoke;
  background: crimson;
  border-radius: .5rem;
}

.dropdown-menu {
  text-align: center;
}

/* #footers {
  position: fixed;
  bottom: 0px;
} */

#menuPanel {
  position: absolute;
  /* top: 100px; */
  background-color: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#startButton {
  height: 50px;
  width: 200px;
  margin: -25px -100px;
  position: relative;
  top: 50%;
  left: 50%;
  font-size: 32px;
}

#progressBar {
  width: 500px;
  height: 24px;
  position: fixed;
  left: 50%;
  top: 110px;
  margin-left: -250px;
}

.selectBox {
  border: 1px solid red;
  background-color: rgba(255, 0, 0, 0.3);
  position: fixed;
}

#my-gui-container {
  position: absolute;
  top: 0px;
  right: 120px;
}

#boatData {
  position: absolute;
  left: 20px;
  bottom: 50px;
  font-size: 17px;
  font-family: monospace;
  color: white;
  pointer-events: none;
}

#locationData {
  position: absolute;
  left: 20px;
  bottom: 20px;
  font-size: 17px;
  font-family: monospace;
  color: white;
  pointer-events: none;
}

#inputfordraw3dsurface {
  position: absolute;
  top: 100px;
}

.measurementLabel {
  font-family: monospace;
  background-color: black;
  color: white;
}
</style>

